/*
 * Copyright (c) 2021 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, January 2021
 */

import {
  Box,
  Image,
  Paragraph,
  TouchableOpacity,
} from '@staffino/primitive-controls';
import React from 'react';

type Target = {
  id: string;
  name: string;
  description?: string;
  imageUrl: string;
};

type TargetComponentProps = {
  target: Target;
  onSelect?: (targetId: Target) => void;
};
const TargetComponent = ({ onSelect, target }: TargetComponentProps) => (
  <Box p={20} alignItems="center" width={1 / 3}>
    <TouchableOpacity onPress={() => onSelect?.(target)} alignItems="center">
      <Image
        source={{ uri: target?.imageUrl, width: 120, height: 120 }}
        borderRadius="50%"
        border="solid 1px rgba(163, 178, 191, 0.2)"
      />
      <Paragraph color="text" fontWeight="bold" mt="0.5rem" lineHeight="normal">
        {target?.name}
      </Paragraph>
    </TouchableOpacity>
  </Box>
);

type Props = {
  targets: Target[];
  onSelect?: (target: Target) => void;
};

const TargetGridBlock = ({ targets, onSelect }: Props) => (
  <Box flexDirection={'row' as const} flexWrap="wrap">
    {targets.map((target) => (
      <TargetComponent key={target.id} target={target} onSelect={onSelect} />
    ))}
  </Box>
);

export default TargetGridBlock;
